const GatedContentPopup = () => {
  const modifiers = {
    active: "popup_active",
  };

  const selectors = {
    triggers: "[data-download]",
    popup: "#gated-content-popup",
    closeButton: "#gated-content-popup .popup__close",
    cardForm: ".card-download__form form",
    cardTitle: ".card-download__title",
    cardDescription: ".card-download__description",
  };

  const elements = {
    triggers: null,
    popup: null,
    closeButton: null,
    form: null,
    title: null,
    description: null,
  };

  const init = () => {
    queryElements();
    registerEvents();
  };

  let card = {
    source: null,
    title: null,
    description: null,
  };

  const queryElements = () => {
    elements.triggers = document.querySelectorAll(selectors.triggers);
    elements.popup = document.querySelector(selectors.popup);
    elements.closeButton = document.querySelector(selectors.closeButton);
    elements.form = document.querySelector(selectors.cardForm);
    elements.title = document.querySelector(selectors.cardTitle);
    elements.description = document.querySelector(selectors.cardDescription);
  };

  const registerEvents = () => {
    elements.triggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();

        card = {
          source: e.currentTarget.dataset.source,
          title: e.currentTarget.dataset.title,
          description: e.currentTarget.dataset.description,
        };

        elements.title.innerHTML = card.title;
        elements.description.innerHTML = card.description;

        openPopup();
      });
    });
    elements.closeButton.addEventListener("click", closePopup);
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closePopup();
      }
    });
    elements.form.addEventListener("submit", () => {
      setTimeout(() => {
        const errors = elements.form.querySelectorAll("._error");

        if (errors.length === 0) {
          window.location.href = card.source;
        }
      }, 1000);
    });
  };

  const openPopup = () => elements.popup.classList.add(modifiers.active);

  const closePopup = () => elements.popup.classList.remove(modifiers.active);

  return {
    init,
  };
};

export default GatedContentPopup;
